import React, { Component, Fragment } from 'react';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
// import get from 'lodash/get';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import { I18nHoc } from 'helpers/i18n';
import { authConnect, UserProp } from 'auth';
import Perms from 'auth/perms';
import apiDecorator from 'api/api-decorator';
import Bem from 'bemHelper';
import beautifyNumber from 'helpers/beautifyNumber';
import formatDate from 'helpers/formatDate';
import { Checkbox } from 'containers/form';
import Button from 'components/button';
import Link from 'components/link';
import { Thumb } from 'components/image';
import Icon, { iconTypes } from 'components/icon';
import Row, { Col } from 'components/row';
import { FavoritesButton } from 'subsys/favorites';
// import { InnerLinks } from 'components/paginator';

import { gotoLastPost, gotoPostById } from './render-common';

import linksForum from 'src-sites/forum/links';

import translates from './translates.json';

import 'styles/forum/section-forum/_item-theme.scss';

const bemClasses = new Bem('themeItem');
const bemClassesTags = new Bem('tags');

const statusesConfig = {
  on_moderation: {
    status: 'on_moderation',
    title: 'На премодерацию',
    mods: 'onModeration',
    icon: iconTypes.flag,
  },
  ban_posts: {
    status: 'ban_posts',
    title: 'Запретить посты Новым пользователям',
    mods: 'banPosts',
    icon: iconTypes.announcement,
  },
  locked: {
    status: 'locked',
    title: 'Тема закрыта',
    mods: 'lock',
    icon: iconTypes.lock,
  },
  stick: {
    status: 'stick',
    title: 'Тема прикреплена',
    mods: 'affix',
    icon: iconTypes.affix,
  },
  important: {
    status: 'important',
    title: 'Важная тема',
    mods: 'important',
    icon: iconTypes.starCircle
  }
};

// Show topics list for current forum.
@authConnect()
@apiDecorator
@I18nHoc(translates)
export default class TopicList extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({}),
    object: PropTypes.shape({}),
    router: routerShape,
    auth: UserProp,
    selectedThemes: PropTypes.arrayOf(PropTypes.shape({})),
    onHandleSelectTheme: PropTypes.func
  };

  // Show first tags.
  showFirstTags(tags) {
    if (!tags || !tags.length) return null;

    return (
      <span {...bemClassesTags({ extra: this.props.className })}>
        {map(tags, (item, index) => (
          <span
            {...bemClassesTags('item')}
            key={`tag-first-${index}`}
          >
            <Link
              {...bemClassesTags('link', `asBtn tag ${item.color ? item.color : ''}`)}
              builder={linksForum.sectionTags}
              builderProps={item}
            >
              <span {...bemClassesTags('linkContent')}>
                <span {...bemClassesTags('text')}>{item.name}</span>
              </span>
            </Link>
          </span>
        ))}
      </span>
    );
  }

  // Show end tags.
  showEndTags(tags) {
    if (!tags || !tags.length) return null;

    return (
      <span {...bemClassesTags({ modifiers: 'end', extra: this.props.className })}>
        {map(tags, (item, index) => (
          <span
            {...bemClassesTags('item')}
            key={`tag-end-${index}`}
          >
            <Link
              {...bemClassesTags('link', 'asBtn tag')}
              builder={linksForum.sectionTags}
              builderProps={item}
            >
              <span {...bemClassesTags('linkContent')}>
                <span {...bemClassesTags('text')}>{item.name}</span>
              </span>
            </Link>
          </span>
        ))}
      </span>
    );
  }

  // Show button statuses.
  renderStatusUnreadPosts(postId) {
    const { i18n } = this;
    const { auth } = this.props;

    if (!auth.authenticated) return null;

    if (postId) {
      return (
        <Button
          {...bemClasses('btn', {
            fill: true,
            lastMessage: true,
            hasLastMessage: true
          })}
          title={i18n('newPosts')}
          onClick={() => gotoPostById.call(this, postId)}
        />
      );
    }

    return (
      <div
        {...bemClasses('btn', 'fill lastMessage')}
        title={i18n('noNewPosts')}
      />
    );
  }

  renderStatuses(statusArray) {
    if (!statusArray) return null;

    return map(statusesConfig, (it, key) => {
      if (!statusArray.includes(it.status)) return null;

      return (
        <Icon key={key} {...bemClasses('icon', it.mods)} title={it.title} type={it.icon} />
      );
    });
  }

  renderTopicInfo(data) {
    const dateThemeCreated = data.topicTime;

    return (
      <div {...bemClasses('info')}>
        {data.topicIsLink &&
          <span {...bemClasses('item', 'isLink')}>
            <span {...bemClasses('text', 'before')}>▪</span>
            <Icon {...bemClasses('icon')} type={iconTypes.newTab} />
          </span>
        }
        <span {...bemClasses('item', 'dateThemeCreated')}>
          <span {...bemClasses('text', 'before')}>▪</span>
          <span {...bemClasses('text')}>
            {formatDate({
              date: dateThemeCreated,
              format: 'dd mmm yyyy'
            })}
          </span>
        </span>
        <span {...bemClasses('item', 'numberViews')} title="просмотров темы">
          <span {...bemClasses('text', 'before')}>▪</span>
          <Icon {...bemClasses('icon')} type={iconTypes.visibility} />
          <span {...bemClasses('text')}>{data.topic_views ? beautifyNumber(data.topic_views) : 0}</span>
        </span>
        <span {...bemClasses('item', 'numberComments')} title="сообщений в теме">
          <span {...bemClasses('text', 'before')}>▪</span>
          <Icon {...bemClasses('icon')} type={iconTypes.commentsOutline} />
          <span {...bemClasses('text')}>{data.topic_posts ? beautifyNumber(data.topic_posts) : 0}</span>
        </span>
      </div>
    );
  }

  render() {
    const { i18n } = this;
    const {
      className, object, selectedThemes, onHandleSelectTheme, inFavorites, checkPermission, auth
    } = this.props;
    const data = object || { ...this.props.data };
    const dateLastPost = data.topicLastPostTime;
    const dateThemeCreated = data.topicTime;
    let imageId = get(data, 'images[0]') || get(data, 'loc_images.others[0].image', '');
    const selectedIndex = selectedThemes ?
      findIndex(selectedThemes, theme => theme.id === data.topic_id) : -1;
    const { toponym } = data;
    const toponyms = getToponyms.call(this, toponym, bemClasses);
    let statuses = [];

    if (data.topic_status) statuses = [...data.topic_status];
    if (checkPermission(Perms.FORUM_CONTROL_PREMODERATION_POST)) {
      if (data.on_moderation) statuses.push('on_moderation')
      if (data.ban_posts) statuses.push('ban_posts')
    }

    return (
      <div
        {...bemClasses(
          {
            modifiers: { admin: !!data.allRules, favorite: inFavorites },
            extra: className
          },
          null
        )}
      >
        <div {...bemClasses('content')}>
          <Row {...bemClasses('row', 'item themes')}>
            <Col {...bemClasses('col', 'theme')} allPr={0}>
              <Row {...bemClasses('row', 'theme')}>
                <Col
                  {...bemClasses('col', 'icons')}
                  allFlex
                  allColumn
                  allAuto
                  allPr={0}
                >
                  {!!statuses.length && this.renderStatuses(statuses)}
                </Col>
                <Col {...bemClasses('col', 'img')} allAuto allPr={0}>
                  <div {...bemClasses('imgContainer')}>
                    <div {...bemClasses('img')}>
                      {this.renderStatusUnreadPosts(data.first_unread_post_id)}
                      <Thumb
                        {...bemClasses('imgPic', { unread: data.first_unread_post_id })}
                        image={{ id: imageId }}
                      />
                      {data.topicIsLink &&
                        <span {...bemClasses('isLink')} />
                      }
                    </div>
                  </div>
                  {this.showFirstTags(data.tagsFirst)}
                  {this.showEndTags(data.tagsEnd)}
                  {/*
                  {get(status, 'type') && get(status, 'text') &&
                    <span
                      {...bemClasses('status', get(status, 'type'))}
                      children={get(status, 'text')}
                    />
                  }
                  */}
                </Col>
                <Col {...bemClasses('col', 'info')} allPr={0}>
                  {data.topic_title && data.topicUrl &&
                    <div {...bemClasses('topic')}>
                      <Link
                        {...bemClasses('link', { unread: !(auth.authenticated && !data.first_unread_post_id) })}
                        builder={linksForum.sectionTopic}
                        builderProps={{
                          ...data,
                          title: data.topic_title,
                          noPage: true
                        }}
                      >
                        <span {...bemClasses('linkContent')}>
                          <span
                            {...bemClasses('text')}
                            dangerouslySetInnerHTML={{__html: data.topic_title}}
                          />
                        </span>
                      </Link>
                    </div>
                  }
                  <div
                    {...bemClasses('links')}
                    children={toponyms}
                  />
                </Col>
              </Row>
              <div {...bemClasses('pages')}>
                <Row {...bemClasses('row', 'pages')}>
                  {dateThemeCreated &&
                    <Col {...bemClasses('col', 'dateLastComment')} allAuto allPr={0}>
                      <span
                        {...bemClasses('text')}
                        children={formatDate({date: dateThemeCreated, format: 'dd.mm.yyyy'})}
                      />
                    </Col>
                  }
                  {/*
                  <Col {...bemClasses('col', 'pages')} allPr={0}>
                    <InnerLinks
                      linkBuilder={linksForum.sectionTopic}
                      linkBuilderProps={data}
                    />
                  </Col>
                  */}
                </Row>
              </div>
            </Col>
            <Col {...bemClasses('col', 'statistics')} allPr={0}>
              <Row {...bemClasses('row', 'statistics')}>
                <Col {...bemClasses('col', 'reply')} allPr={0}>
                  <div {...bemClasses('label')} children={i18n('answers')} />
                  <div {...bemClasses('text')} children={data.topic_posts ? beautifyNumber(data.topic_posts) : 0} />
                </Col>
                <Col {...bemClasses('col', 'views')} allPr={0}>
                  <div {...bemClasses('label')} children={i18n('views')} />
                  <div {...bemClasses('text')} children={data.topic_views ? beautifyNumber(data.topic_views) : 0} />
                </Col>
                {dateLastPost && data.topic_last_post_id &&
                  <Col {...bemClasses('col', 'lastComment')} allPr={0}>
                    <div {...bemClasses('label')} children={i18n('lastMessage')} />
                    <Button
                      {...bemClasses('btn', 'toTopic')}
                      onClick={() => gotoLastPost.call(this, data.topic_last_post_id)}
                      title={i18n('goToLastPost')}
                      label={
                        formatDate({
                          date: dateLastPost,
                          format: 'dd.mm.yyyy HH:MM'
                        })
                      }
                    />
                  </Col>
                }
              </Row>
            </Col>
            {inFavorites &&
              <Col {...bemClasses('col', 'favorites')} allPr={0}>
                <FavoritesButton
                  {...bemClasses('favorites')}
                  project="forum"
                  entity="publication"
                  entityId={data.topic_id}
                  subgroup="forum_topic"
                  inFavorites
                  hideLabel
                />
              </Col>
            }
            {data.allRules && onHandleSelectTheme &&
              <Checkbox
                {...bemClasses('checkbox', 'admin')}
                value={selectedIndex >= 0}
                onChange={checked => onHandleSelectTheme(
                  checked,
                  { id: data.topic_id, title: data.topic_title }
                )}
                disableValidationState
                withIcon
                noPadding
                noLabel
                noError
              />
            }
          </Row>
          {/*
          <Row mpColumn>
            <Col
              allPr={0}
              mdPt={20}
              mdPl={56}
              mtPt={23}
              mtPl={56}
              mpPt={15}
              mpPl={50}
            >
              <div>
                <Link
                  {...bemClasses('link', 'topic')}
                  builder={linksForum.sectionTopic}
                  builderProps={{
                    ...data,
                    noPage: true
                  }}
                >
                  <span {...bemClasses('linkContent')}>
                    <span
                      {...bemClasses('text')}
                      dangerouslySetInnerHTML={{__html: data.topic_title}} // eslint-disable-line
                    />
                  </span>
                </Link>
              </div>
              <div {...bemClasses('infoContainer')}>
                {this.renderTopicInfo(data)}
                 Show first color tags
                {this.showFirstTags(data.tagsFirst)}
                 Show end grey tags
                {this.showEndTags(data.tagsEnd)}
              </div>
            </Col>
          </Row>
          <Row mpColumn>
            <Col
              allPt={0}
              allPr={0}
              mdPl={56}
              mdPb={20}
              mtPb={23}
              mtPl={56}
              mpPb={0}
              mpPl={50}
            >
              {dateLastPost &&
                <span {...bemClasses('dateLastPost')}>
                  <span {...bemClasses('text', 'label')}>Последний ответ:&ensp;</span>
                  <Link
                    {...bemClasses('link', 'lastPost')}
                    builder={linksForum.pagePostLastTopic}
                    builderProps={{
                      ...data,
                      topic_title: 'К последнему сообщению'
                    }}
                  >
                    <span {...bemClasses('linkContent')}>
                      <span {...bemClasses('text')}>
                        {formatDate({
                          date: dateLastPost,
                          format: 'HH:MM, dd mmm yyyy'
                        })}
                      </span>
                    </span>
                  </Link>
                </span>
              }
            </Col>
            <Col
              allAuto
              allPt={0}
              allPr={0}
              mdPb={20}
              mdPl={20}
              mtPb={23}
              mtPl={20}
              mpPl={50}
              mpPb={15}
            >
              <div {...bemClasses('paginator')}>
                <InnerLinks
                  linkBuilder={linksForum.sectionTopic}
                  linkBuilderProps={data}
                />
              </div>
            </Col>
          </Row>
          {data.topic_status &&
            <div {...bemClasses('statusIcon')}>
              {this.renderStatuses(data.topic_status)}
            </div>
          }
          */}
        </div>
      </div>
    );
  }
}

function getToponyms(toponym) {
  if (!toponym || !toponym.name) return null;

  const { i18n } = this;

  return (
    <div {...bemClasses('toponym')} key="toponyms">
      <span {...bemClasses('item')}>
        <span {...bemClasses('text')}>
          {toponym && toponym.name &&
            <>
              {toponym.type === 'subway_station' &&
                <><Icon {...bemClasses('icon', 'metro')} type={iconTypes.metro} />{'\u00a0'}</>
              }
              {toponym.name}
              {toponym.pedestrain > 0 &&
                <>
                  {`\u2002\u2013\u2002${toponym.pedestrain}\u00a0${i18n('textMinutes')}\u00a0`}<Icon {...bemClasses('icon', 'walk')} type={iconTypes.walk} />
                </>
              }
            </>
          }
        </span>
      </span>
    </div>
  );
}
